import { BusinessDocumentSchema } from 'services/businessDocuments';
import { ERPPreferencesDataSchema } from 'services/erp';
import {
  CountryBusinessDocumentTypeXrefSchema,
  CountryBusinessLegalEntityXrefSchema,
} from 'services/countries';

export interface ApplicantProps {
  applicantName: string;
  applicantEmail: string;
  applicantPhone: string;
  applicantRole: string;
  personsId: number;
}

export interface BusinessDocumentType extends BusinessDocumentSchema {
  id: number;
}

export interface BusinessInfoState {
  documents: BusinessDocumentSchema[];
  applicant: ApplicantProps;
  erpPreferences: ERPPreferencesDataSchema | null;
  isFormUpdate: boolean;
  showDoingBusinessAs: boolean;
  loadingProgress: number;
  idTypes: CountryBusinessDocumentTypeXrefSchema[];
  legalEntityTypes: CountryBusinessLegalEntityXrefSchema[];
  idTypesCountryId: number;
  isSaving: boolean;
}

export enum BusinessDocumentTypes {
  federalTaxId = 1,
  dbaStatement = 2,
  centralIndexKey = 3,
}
